import Hero, { HeroLayoutProps } from "@/libraries/design/patterns/hero/src";
import { useLocalizedHref } from "@/libraries/web-framework";

type UniformHeroSectionProps = {
    heading: string;
    subheading?: string;
    layout?: HeroLayoutProps;
    buttonHref?: {
        path: string;
    };
    buttonLabel?: string;
    imageUrl?: string;
    imageAlt?: string;
};

const UniformHeroSection = (props: UniformHeroSectionProps) => {
    const localizedButtonHref = useLocalizedHref(props.buttonHref?.path ?? "");

    return (
        <Hero
            heading={props.heading}
            subheading={props.subheading}
            layout={props.layout ?? "image-right"}
            callToActionProps={
                props.buttonHref && props.buttonLabel
                    ? {
                          text: props.buttonLabel,
                          href: localizedButtonHref
                      }
                    : undefined
            }
            imageProps={
                props.imageUrl
                    ? {
                          src: props.imageUrl,
                          alt: props.imageAlt ?? ""
                      }
                    : undefined
            }
        />
    );
};

export default UniformHeroSection;
